import {API_DRIVER} from "../configs/axios";

const RefreshCacheService = {
    cacheSims: (integrationId) => {
        return API_DRIVER.get("/api/cache/sims", {
            params: {
                integrationId
            }
        })
    },
    cacheDigitalContract: (integrationId) => {
        return API_DRIVER.get("/api/cache/digital-contract", {
            params: {
                integrationId
            }
        })
    }
}

export default RefreshCacheService
